import { render, staticRenderFns } from "./dispatcher_performance_report.vue?vue&type=template&id=5f49f2c1&"
import script from "./dispatcher_performance_report.vue?vue&type=script&lang=js&"
export * from "./dispatcher_performance_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports